import React, { useLayoutEffect, useRef, useState } from 'react'

const tabValue = (tab, index) => (tab.value !== undefined ? tab.value : index)

export default function TabsSimple({
    tabs = [],
    selectedTab = 0,
    onChange = () => {},
    className = '',
    dataAttributes = {}
}) {
    let classes = 'uiTabSimple'
    if (className) {
        classes += ' ' + className
    }

    const data = {}
    if (dataAttributes) {
        for (const prop in dataAttributes) {
            data['data-' + prop] = dataAttributes[prop]
        }
    }

    const trackRef = useRef(null)
    const tabRefs = useRef([])
    const [selectedMetrics, setSelectedMetrics] = useState({ left: 0, width: 0, ready: false })
    const [hoverIndex, setHoverIndex] = useState(null)
    const [hoverParked, setHoverParked] = useState(false)
    const [hoverMetrics, setHoverMetrics] = useState({ left: 0, width: 0, index: null })

    // DeviceToggle values are not visual order (Desktop 0, Tablet 2, Mobile 1).
    const selectedIndex = tabs.findIndex((tab, index) => selectedTab == tabValue(tab, index))

    useLayoutEffect(() => {
        const measure = (index) => {
            const el = tabRefs.current[index]
            if (!el) return null
            return { left: el.offsetLeft, width: el.offsetWidth }
        }

        const update = () => {
            const selected = measure(selectedIndex)
            if (selected) {
                setSelectedMetrics({ ...selected, ready: true })
            }
            if (hoverIndex != null) {
                const hover = measure(hoverIndex)
                if (hover) {
                    setHoverMetrics({ ...hover, index: hoverIndex })
                }
            }
        }

        update()

        const track = trackRef.current
        if (!track || typeof ResizeObserver === 'undefined') return undefined

        const observer = new ResizeObserver(update)
        observer.observe(track)
        return () => observer.disconnect()
    }, [selectedIndex, hoverIndex, tabs.length])

    useLayoutEffect(() => {
        if (!hoverParked) return undefined
        const frame = requestAnimationFrame(() => setHoverParked(false))
        return () => cancelAnimationFrame(frame)
    }, [hoverParked])

    const hoverVisible = hoverIndex != null && hoverIndex !== selectedIndex && hoverMetrics.index === hoverIndex

    const handleTrackLeave = () => {
        setHoverIndex(null)
        setHoverParked(false)
    }

    const handleTabEnter = (index) => {
        if (hoverIndex == null) {
            setHoverParked(true)
        }
        setHoverIndex(index)
    }

    return (
        <div ref={trackRef} className={classes} onMouseLeave={handleTrackLeave} {...data}>
            <div
                className='uiTabSimple-indicator uiTabSimple-indicator--selected'
                style={{
                    transform: `translate3d(${selectedMetrics.left}px, 0, 0)`,
                    width: selectedMetrics.width,
                    opacity: selectedMetrics.ready ? 1 : 0
                }}
                aria-hidden='true'
            />
            <div
                className={
                    'uiTabSimple-indicator uiTabSimple-indicator--hover' +
                    (hoverVisible ? ' is-visible' : '') +
                    (hoverParked ? ' is-parked' : '')
                }
                style={{
                    transform: `translate3d(${hoverMetrics.left}px, 0, 0)`,
                    width: hoverMetrics.width
                }}
                aria-hidden='true'
            />
            {tabs.map((tab, index) => {
                let tabClassName = 'uiTabSimple-tab'
                if (selectedTab == tabValue(tab, index)) {
                    tabClassName += ' uiTabSimple-tab-selected'
                }
                return (
                    <div
                        key={index}
                        ref={(el) => {
                            tabRefs.current[index] = el
                        }}
                        className={tabClassName}
                        onMouseEnter={() => handleTabEnter(index)}
                        onClick={() => {
                            onChange(tabValue(tab, index))
                        }}
                    >
                        {tab.label}
                    </div>
                )
            })}
        </div>
    )
}
